import { Component, OnInit, ViewChild } from '@angular/core';
import { HomeService } from './home.service';
import {SharedService} from '../shared.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { AuthService } from '../auth.service';
import { environment } from '../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Rx';
import { window } from 'rxjs/operator/window';



@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  apiUrl = environment.apiBaseUrl;
  // TODO bogdan: replace this with tenant code from sessionData

  // premium user or not
  userType;
  premium: boolean;

  responseData: any[];

  defaultTenant;
  data: {};
  obj: {};

  firstObject: {};
  secondObject: {};
  thirdObject: {};
  fourthObject: {};

  admin;
  id: number;
  header: string;
  price: string;
  imgSrc: string;
  subText: string;
  subTextI: string;
  subHeader: string;
  shortText: string;

  id1: number;
  header1: string;
  price1: string;
  imgSrc1: string;
  subText1: string;
  subText1I: string;
  subHeader1: string;
  shortText1: string;

  id2: number;
  header2: string;
  price2: string;
  imgSrc2: string;
  subText2: string;
  subText2I: string;
  subHeader2: string;
  shortText2: string;

  id3: number;
  header3: string;
  price3: string;
  subText3: string;
  subText3I: string;
  imgSrc3: string;
  subHeader3: string;
  shortText3: string;

  modeEvnironment: boolean;

  baseForAdminPage: string;

  // categories for offer windows
  category;
  category1;
  category2;
  category3;

  // for sending to admin fe
  sessionId;

  constructor(
    private homeService: HomeService,
    private sharedService: SharedService,
    private authService: AuthService,
    private router: Router,
    private translate: TranslateService
  ) {

    this.translate.onLangChange.subscribe(
      changed => {
        console.log(changed);
      });
      let temp = this.authService.getSession().subscribe(
        sessionData => {
            this.userType = sessionData.homepage.type;
            this.baseForAdminPage = sessionData.homepage.adminpage;
            this.defaultTenant = sessionData.tenantCode;
            this.sharedService.getUserType().subscribe(userType => {
              this.userType = userType;
              if (this.userType === 'simpleTravel') {
                this.premium = true;
              }else {
                this.premium = false;
              }
              this.getOfferWindows();
            },
            err => console.log('error'),
            () => console.log('complete')
          );
            this.sharedService.getData().subscribe(data => {
            this.admin = data;
            });
              if ( sessionData.isLoggedIn === true) {
                this.admin = true;
              }else {
                this.admin = false;
              }
          scrollTo(0, 0);
          this.sessionId = localStorage.getItem('sessionId');
        });
        this.getOfferWindows();

    }

  getOfferWindows() {
    this.emptyData();
    if (this.userType === undefined) {
      this.userType = 'simpleTravel';
    }
    this.homeService.getOfferWindow().subscribe(
      obj => {
        this.data = obj;
        this.responseData = new Array();
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            this.responseData.push(obj[key]);
          }
        }
      if(obj[1] != null){
        this.firstObject = obj[1];
        this.id = this.firstObject[this.userType].id,
        this.header = this.firstObject[this.userType].header,
        this.subText = this.firstObject[this.userType].subText1;
        this.subTextI = this.firstObject[this.userType].subText2;
        this.subHeader = this.firstObject[this.userType].subHeader,
        this.shortText = this.firstObject[this.userType].shortText,
        this.category = this.firstObject[this.userType].accommodation.category,
        // tslint:disable-next-line:max-line-length
        this.price = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.firstObject[this.userType].fromPrice / 100);
        if (typeof this.firstObject[this.userType].files !== 'undefined') {
          for (let image of this.firstObject[this.userType].files){
            if (image.main === true) {
              this.imgSrc = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + image.id;
            }
          }
        }else {
          this.imgSrc = 'https://www.novelupdates.com/img/noimagefound.jpg';
        }
      }

      if(obj[2] != null){
        this.secondObject = obj[2];
        this.id1 = this.secondObject[this.userType].id,
        this.header1 = this.secondObject[this.userType].header,
        this.subText1 = this.secondObject[this.userType].subText1,
        this.subText1I = this.firstObject[this.userType].subText2;
        this.subHeader1 = this.secondObject[this.userType].subHeader,
        this.shortText1 = this.secondObject[this.userType].shortText,
        this.category1 = this.secondObject[this.userType].accommodation.category,
        // tslint:disable-next-line:max-line-length
        this.price1 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.secondObject[this.userType].fromPrice / 100);
        if (typeof this.secondObject[this.userType].files !== 'undefined') {
          for (let image of this.secondObject[this.userType].files){
            if (image.main === true) {
              this.imgSrc1 = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + image.id;
            }
          }
        }else {
          this.imgSrc1 = 'https://www.novelupdates.com/img/noimagefound.jpg';
        }
      }

      if(obj[3] != null){
        this.thirdObject = obj[3];
        this.id2 = this.thirdObject[this.userType].id,
        this.header2 = this.thirdObject[this.userType].header,
        this.subText2 = this.thirdObject[this.userType].subText1,
        this.subText2I = this.firstObject[this.userType].subText2;
        this.subHeader2 = this.thirdObject[this.userType].subHeader,
        this.shortText2 =this.thirdObject[this.userType].shortText,
        this.category2 = this.thirdObject[this.userType].accommodation.category,
        // tslint:disable-next-line:max-line-length
        this.price2 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.thirdObject[this.userType].fromPrice / 100);
        if (typeof this.thirdObject[this.userType].files !== 'undefined') {
          for (let image of this.thirdObject[this.userType].files){
            if (image.main === true) {
              this.imgSrc2 = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + image.id;
            }
          }
        }else {
          this.imgSrc2 = 'https://www.novelupdates.com/img/noimagefound.jpg';
        }
      }

      if (obj[4] != null) {
        this.fourthObject = obj[4];
        this.id3 = this.fourthObject[this.userType].id,
        this.header3 = this.fourthObject[this.userType].header,
        this.subText3 = this.fourthObject[this.userType].subText1,
        this.subText3I = this.firstObject[this.userType].subText2;
        this.subHeader3 = this.fourthObject[this.userType].subHeader,
        this.shortText3 = this.fourthObject[this.userType].shortText,
        this.category3 = this.fourthObject[this.userType].accommodation.category,
        // tslint:disable-next-line:max-line-length
        this.price3 = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(this.fourthObject[this.userType].fromPrice / 100);
        if (typeof this.fourthObject[this.userType].files !== 'undefined') {
          for (let image of this.fourthObject[this.userType].files){
            if (image.main === true) {
              this.imgSrc3 = this.apiUrl + 'dms/public/' + this.defaultTenant + '/' + image.id;
            }
          }
        }else {
          this.imgSrc3 = 'https://www.novelupdates.com/img/noimagefound.jpg';
        }

      }

    },
    err => {
      this.imgSrc = '../../assets/img/trash/error.png';
      this.header = 'Error occured, stattus ' + err.statusl;
    } ,
    () => console.log('complete')
    );
  }

  onSelect(url) {
    this.sessionId = localStorage.getItem('sessionId');
        let win = open(url + '?=' + this.sessionId, '_blank');
        win.focus();
  }

  onDetails(id) {
    this.router.navigate(['/details', id]);
  }

  onInquiry(id) {
    this.router.navigate(['/inquiry', id]);
  }

  emptyData() {
    this.id = null;
    this.header = '';
    this.price = '';
    this.imgSrc = '';
    this.subText = '';
    this.subHeader = '';
    this.shortText = '';

    this.id1 = null;
    this.header1 = '';
    this.price1 = '';
    this.imgSrc1 = '';
    this.subText1 = '';
    this.subHeader1 = '';
    this.shortText1 = '';

    this.id2 = null;
    this.header2 = '';
    this.price2 = '';
    this.imgSrc2 = '';
    this.subText2 = '';
    this.subHeader2 = '';
    this.shortText2 = '';

    this.id3 = null;
    this.header3 = '';
    this.price3 = '';
    this.subText3 = '';
    this.imgSrc3 = '';
    this.subHeader3 = '';
    this.shortText3 = '';
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts